import { useState } from "react";

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navElements = [
    { About: "#about" },
    { Projects: "#projects" },
    { Skills: "#skills" },
    { Contact: "#contact" },
  ];

  return (
    <nav className="fixed w-full z-50 top-0 start-0 border-b border-white/10 bg-[#0a0a0a]/85 backdrop-blur-md">
      <div className="max-w-7xl flex flex-wrap items-center justify-between mx-auto p-4 animate__animated custom-delay-2">
        <a href="#home" className="flex items-center group">
          <span className="text-2xl font-black tracking-tight whitespace-nowrap transition-opacity group-hover:opacity-80">
            <span className="text-[#f15700]">Sashank</span> <span className="text-white">Pilli</span>
          </span>
        </a>
        <button
          type="button"
          className="group relative inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-[#f15700]/80 bg-[#f15700]/10 text-gray-200 shadow-[0_0_18px_rgba(241,87,0,0.18)] transition-all duration-300 hover:bg-[#f15700]/20 hover:text-white focus:outline-none focus:ring-2 focus:ring-[#f15700] focus:ring-offset-2 focus:ring-offset-[#0a0a0a] md:hidden"
          aria-controls="navbar-default"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span className="sr-only">{isMenuOpen ? "Close main menu" : "Open main menu"}</span>
          <span
            className={`absolute h-0.5 w-6 rounded-full bg-current transition-all duration-300 ${
              isMenuOpen ? "translate-y-0 rotate-45" : "-translate-y-2"
            }`}
          ></span>
          <span
            className={`absolute h-0.5 w-6 rounded-full bg-current transition-all duration-300 ${
              isMenuOpen ? "opacity-0" : "opacity-100"
            }`}
          ></span>
          <span
            className={`absolute h-0.5 w-6 rounded-full bg-current transition-all duration-300 ${
              isMenuOpen ? "translate-y-0 -rotate-45" : "translate-y-2"
            }`}
          ></span>
        </button>
        <div
          className={`w-full overflow-hidden transition-all duration-300 ease-out md:block md:w-auto md:overflow-visible ${
            isMenuOpen ? "max-h-80 opacity-100" : "max-h-0 opacity-0 md:max-h-none md:opacity-100"
          }`}
          id="navbar-default"
        >
          <ul className="mt-4 flex flex-col gap-2 rounded-2xl border border-white/10 bg-[#0a0a0a]/95 p-3 font-medium shadow-2xl shadow-black/30 md:mt-0 md:flex-row md:gap-0 md:space-x-8 md:border-0 md:bg-transparent md:p-0 md:shadow-none">
            {navElements.map((ele, index) => {
              const [text, href] = Object.entries(ele)[0];
              return (
                <li key={index}>
                  <a
                    href={href}
                    className="flex items-center justify-between rounded-xl px-4 py-3 text-gray-200 transition-all duration-300 hover:bg-white/5 hover:text-[#f15700] md:block md:rounded-none md:p-0 md:text-gray-300 md:hover:bg-transparent"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <span>{text}</span>
                    <span className="h-2 w-2 rounded-full bg-[#f15700]/70 md:hidden"></span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </nav>
  );
};
